module.exports = __webpack_public_path__ + "img/6.ed1c0546.jpg";